module.exports = __webpack_public_path__ + "img/message.5b74c3d2.svg";